import { IconContext } from "react-icons";
import { BsEyeFill as Eye, BsEyeSlashFill as SlashEye } from "react-icons/bs";
import InlineError from "../InlineError/InlineError";
import {
  FIELD_DEFAULT_VARIANT,
  INPUT_FIELD_VARIANT_CLASSES,
  resolveFieldVariant,
} from "../InputField/fieldSystem";

export default function PasswordField({
  className = "",
  error,
  variant = FIELD_DEFAULT_VARIANT.password,
  fullWidth = false,
  passwordtype,
  setpasswordtype,
  ...restProps
}) {
  const inputType = passwordtype === "true" ? "password" : "text";
  const resolvedKey = resolveFieldVariant(
    INPUT_FIELD_VARIANT_CLASSES[variant] ? variant : FIELD_DEFAULT_VARIANT.password,
    fullWidth
  );
  const fieldClass =
    `${INPUT_FIELD_VARIANT_CLASSES[resolvedKey]} !pr-11 ${className}`.trim();

  const toggle = () => {
    setpasswordtype?.(passwordtype === "true" ? "false" : "true");
  };

  return (
    <div className="relative w-full min-w-0">
      <div className="relative w-full">
        <input
          {...restProps}
          type={inputType}
          className={fieldClass}
        />
        <button
          type="button"
          className="absolute right-3 top-1/2 flex -translate-y-1/2 cursor-pointer items-center justify-center text-offblack"
          onClick={toggle}
          aria-label={inputType === "password" ? "Show password" : "Hide password"}
        >
          <IconContext.Provider value={{ className: "size-4" }}>
            {passwordtype === "true" ? <SlashEye /> : <Eye />}
          </IconContext.Provider>
        </button>
      </div>
      <InlineError message={error} />
    </div>
  );
}
